import React, { useState } from 'react';  
import { Link, useNavigate } from 'react-router-dom';  
import { Navbar,Nav,NavDropdown,Container,Button } from 'react-bootstrap';  
import Offcanvas from 'react-bootstrap/Offcanvas';
import './App.css';  

const NavbarComponent = () => {
	let navigate = useNavigate();
	const goToLogin = () => {
		navigate("/login");
	}
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	return (
		<>
		<Navbar collapseOnSelect expand="lg" className='default-navbar-bg' fixed="top">
			<Container>
				<Navbar.Brand>
					<Link to="/">
					<div className='row'>
						<div className='col-2'><img className="logo" src="/images/kanglasha.png" width="50" alt="Kanglasha" /></div>
						<div className='col-10'>
							<div className="app-name"> eBudget Manipur<br/></div>
							<div className="app-name-small nomobile"> Finance Department, Government of Manipur</div>
							<div className="app-name-small mobile"> Finance Department,<br/> Government of Manipur</div>
						</div>
						</div>
					</Link>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="me-auto"></Nav>
					{(sessionStorage.getItem('user') == null)?
					<Nav>
						<Nav.Link href="#" onClick={handleShow}>About</Nav.Link>
						<Nav.Link href="#" onClick={goToLogin}>Login</Nav.Link>

					</Nav>
					:<></>}
				</Navbar.Collapse>
			</Container>
		</Navbar>

		<Offcanvas show={show} onHide={handleClose}>
			<Offcanvas.Header closeButton style={{backgroundColor:"#3998ac"}}>
				<Offcanvas.Title></Offcanvas.Title>
			</Offcanvas.Header>
			<h6 className='font-custom text-center custom-block'>
				<img className="" src="/images/ebudget.png" width="70" alt="Kanglasha" />
				<span className="app-name-small">eBudget Manipur</span>
			</h6>
				<Offcanvas.Body className='font-custom link p-5'>
				<div style={{textAlign: "justify"}}>
					<p>
						eBudget webapp provides State Budget
						information to various stakeholders and facilitates
						access of budget documents to the Legislators, officials
						and general public at one place at the click of a button.
					</p>
					<p>
						Viewing of State Budget documents, including Demands
						for Grants (DG), Annual Financial Statement (AFS),
						Budget Speech, Supplementary Demands Speech,
						Manipur FRBM Ordinance etc. are made available in
						digital mode in an eco-friendly manner.
					</p>
				</div>
			</Offcanvas.Body>
			<div className='canvasfooter'>&nbsp;</div>
      	</Offcanvas>
	  </>
	)
}
export default NavbarComponent